import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isOnline } from 'common/components/NetworkStatus';
import './index.css';

const Card = props => {
  const {
    action,
    availableOffline,
    children,
    className,
    handleUnavailableClick,
    header,
    headerright,
    headersub,
    link,
    theme,
    top,
    footer,
  } = props;
  const CardCSS = cn(
    'card',
    className,
    theme ? theme.map(css => `card--${css}`).join(' ') : ''
  );

  const renderLink = () => {
    // link must be used for internal links, for onClick trigger, specify in action
    if (action) {
      return <a onClick={action} className={'card__cover'} />;
    }
    if (link) {
      if (availableOffline || isOnline()) {
        return <Link to={link} className={'card__cover'} />;
      }
      return <a onClick={handleUnavailableClick} className={'card__cover'} />;
    }
    return null;
  };

  return (
    <article className={CardCSS}>
      <div className={'card__inner'}>
        {top && <div className={'card__top'}>{top}</div>}
        {header && (
          <header className={'card__header'}>
            <div className={'card__header-inner'}>
              {header}
              {headerright}
            </div>
            {headersub && <small>{headersub}</small>}
          </header>
        )}
        {children}
        {footer && <footer className={'card__footer'}>{footer}</footer>}
      </div>
      {renderLink()}
    </article>
  );
};

Card.propTypes = {
  action: PropTypes.func,
  availableOffline: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  handleUnavailableClick: PropTypes.func,
  header: PropTypes.node,
  headerright: PropTypes.node,
  headersub: PropTypes.string,
  theme: PropTypes.array,
  link: PropTypes.string, // link to make whole card clickable - do not use for the contents include links
  top: PropTypes.node,
  footer: PropTypes.node,
};

export default Card;



// WEBPACK FOOTER //
// ./src/common/components/Card/index.js